import "./App.css";
import ErrorPage from "./screens/error-page";
import { createBrowserRouter, redirect } from "react-router-dom";
import ATTOTE from "./screens/ATTOTE";
import LAPAIX from "./screens/LAPAIX";
import SHILAJIT from "./screens/SHILAJIT";
import VIGA from "./screens/VIGA";
import FITTEA from "./screens/FITTEA";
import MINOXIDIL from "./screens/MINOXIDIL";
import HAIRNOWNOW from "./screens/HAIRNOWNOW";
import DISAAR from "./screens/DISAAR";
import DAMATOL from "./screens/DAMATOL";
import SERUMVISAGE from "./screens/SERUMVISAGE";
import LANBENA from "./screens/LANBENA";
import LXRMIMI from "./screens/LXRMIMI";
import HAIRREMOVAL from "./screens/HAIRREMOVAL";
import ANTIPOIL from "./screens/ANTIPOIL";
import CHIPSALLOCO from "./screens/CHIPSALLOCO";
import PATCHDETOX from "./screens/PATCHDETOX";
import MAITYSERUM from "./screens/MAITYSERUM";
import MAITYPOMMADE from "./screens/MAITYPOMMADE";
import MAITYPOUSSE from "./screens/MAITYPOUSSE";
import BIGMAN from "./screens/BIGMAN";

const App = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
  },
  {
    path: "/attote",
    element: <ATTOTE />,
  },
  {
    path: "/lapaix",
    element: <LAPAIX />,
  },
  {
    path: "/shilajit",
    element: <SHILAJIT />,
  },
  {
    path: "/hairremoval",
    element: <HAIRREMOVAL />,
  },
  {
    path: "/antipoil",
    element: <ANTIPOIL />,
  },
  {
    path: "/viga",
    element: <VIGA />,
  },
  {
    path: "/jjl60mn",
    loader: () => {
      return redirect("/viga");
    },
  },
  {
    path: "/maitypousse",
    element: <MAITYPOUSSE />,
  },
  {
    path: "/fittea",
    element: <FITTEA />,
  },
  {
    path: "/minoxidil",
    element: <MINOXIDIL />,
  },
  {
    path: "/patchdetox",
    element: <PATCHDETOX />,
  },
  {
    path: "/hairnownow",
    element: <HAIRNOWNOW />,
  },
  {
    path: "/disaar",
    element: <DISAAR />,
  },
  {
    path: "/damatol",
    element: <DAMATOL />,
  },
  {
    path: "/serumvisage",
    element: <SERUMVISAGE />,
  },
  {
    path: "/lanbena",
    element: <LANBENA />,
  },
  {
    path: "/lxrmimi",
    element: <LXRMIMI />,
  },
  {
    path: "/chipsalloco",
    element: <CHIPSALLOCO />,
  },
  {
    path: "/bigman",
    element: <BIGMAN />,
  },
  {
    path: "/maitypommade",
    element: <MAITYPOMMADE />,
  },
  {
    path: "/maityserum",
    element: <MAITYSERUM />,
  },
]);

export default App;
